import { render } from "./RestaurantWelcome.vue?vue&type=template&id=829a3590"
import script from "./RestaurantWelcome.vue?vue&type=script&lang=js"
export * from "./RestaurantWelcome.vue?vue&type=script&lang=js"

import "./RestaurantWelcome.vue?vue&type=style&index=0&id=829a3590&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__